import {
    Button,
    Dialog, DialogContent, DialogContentText, Typography
} from '@material-ui/core'
import Paper from '@material-ui/core/Paper'
import { makeStyles, withStyles } from '@material-ui/core/styles'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableContainer from '@material-ui/core/TableContainer'
import TableRow from '@material-ui/core/TableRow'
import { AccessAlarmOutlined } from '@material-ui/icons'
import * as React from 'react'

import { buttonsStyles } from '../../styles/ButtonsStyles'
import { escapeRoomStyles } from '../../styles/EscapeRoomStyles'
import { textStyles } from '../../styles/TextStyles'
import { formatTimeline } from '../../utils/helper'
import { PuzzleDto } from '../../utils/types'

interface Props {
    title: string
    open: boolean
    materials?:string[]
    bannerImage?: string
    description: string
    descriptionImage?: string
    continueButtonTitle?: string
    onClose(): void
    onContinue?(): void
    puzzles: PuzzleDto[]
}

const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: theme.palette.common.black,
        color: theme.palette.common.white,
    },
    body: {
        fontSize: 14,
    },
}))(TableCell)

const StyledTableRow = withStyles((theme) => ({
    root: {
        '&:nth-of-type(odd)': {
            backgroundColor: theme.palette.action.hover,
        },
    },
}))(TableRow)

const useStyles = makeStyles({
    table: {
        minWidth: 'fit-content',
    },
})

export const EscapeRoomDetailsModal: React.FC<Props> = ({
    title,
    description, onClose, onContinue, continueButtonTitle,
    open, puzzles, descriptionImage, bannerImage, materials
}) => {

    const eRoomStyles = escapeRoomStyles()
    const tStyles = textStyles()
    const btnStyles = buttonsStyles()
    const classes = useStyles()

    const totalTime = puzzles.map((pz) => pz.seconds).reduce((p, c) => p + c, 0)
    return (
        <Dialog
            className={eRoomStyles.dialog}
            open={open}
            keepMounted
            aria-describedby="alert-dialog-slide-description">
            <div style={{
                backgroundImage: `linear-gradient(rgba(0,0,0,0.5),rgba(0,0,0,0.5)), url(${bannerImage})`,
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'cover',
                width: 600,
                height: 150,
                display: 'flex',
                justifyContent: 'space-between',
                flexDirection: 'column',
            }}>
                <Button className={btnStyles.closeModalE} onClick={onClose}>X</Button>
            </div>

            <div className={eRoomStyles.divTittle}>

                <Typography className={tStyles.escapeRoomTittle}>{title}</Typography>

            </div>
            <DialogContent className={eRoomStyles.dialogContent}>
                <DialogContentText
                    className={eRoomStyles.contentText}
                    id="alert-dialog-slide-description">
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                        {description}
                        {descriptionImage && (
                            <div style={{
                                display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center'
                            }}>
                                <img
                                    style={{
                                        display: 'flex', justifyContent: 'center', width: 200, height: 200
                                    }}
                                    src={descriptionImage}
                                    alt={title}/>
                            </div>

                        )}

                    </div>

                </DialogContentText>

                <div>
                    {materials && materials.map((m) => {
                        return (
                            <p>{m}</p>
                        )
                    })}
                </div>
                <TableContainer component={Paper}>
                    <Table className={classes.table} aria-label="customized table">

                        <TableBody>
                            {puzzles.map((pz, index) => {
                                const color = index % 2 ? '#33949F' : '#70c7de'
                                return (
                                    <StyledTableRow style={{ backgroundColor: color }} key={pz.puzzleId}>

                                        <StyledTableCell
                                            style={{ color: 'white' }}
                                            align="left"> {index + 1} - {pz.puzzleId}
                                        </StyledTableCell>

                                        <StyledTableCell
                                            style={{
                                                color: 'white',
                                                display: 'flex',
                                                justifyContent: 'center',
                                                alignItems: 'center'
                                            }}
                                            align="left"><AccessAlarmOutlined style={{ color: 'white' }}/>
                                            {formatTimeline(pz.seconds)}
                                        </StyledTableCell>

                                    </StyledTableRow>
                                )
                            })}

                        </TableBody>
                    </Table>
                </TableContainer>
                <div style={{
                    color: 'white',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    padding: 30,
                    flexDirection: 'row'
                }}>
                    <AccessAlarmOutlined style={{ color: 'white' }}/>
                    <p style={{ color: 'white' }}>{formatTimeline(totalTime)}</p>
                </div>
            </DialogContent>
            {onContinue && (
                <Button
                    className={btnStyles.chooseTask}
                    onClick={onContinue}>
                    {continueButtonTitle}
                </Button>
            )}
        </Dialog>
    )
}
EscapeRoomDetailsModal.defaultProps = {
    onContinue: undefined,
    continueButtonTitle: undefined,
    descriptionImage: '',
    bannerImage: '',
    materials: []
}
